import { PageSkeleton } from '@/components/templates/page-skeleton'
import { StaffBrandHeader } from '@/components/StaffBrandHeader'
import { Alert } from '@/components/ui/alert'

export function StaffSessionLoading() {
  return <PageSkeleton layout="staff" label="Checking staff session..." />
}

export function StaffIdentityError({ brand }: { brand: string }) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm">
        <StaffBrandHeader brand={brand} />
        <Alert>Unable to load staff access. Please try again.</Alert>
      </div>
    </main>
  )
}
